import Popup from '../popup'

export default class MobileFilter extends Popup {
	static title = 'mobile-filter'

	init() {
		super.init()

		this.filterTypes = this.getElements('filter-type')
		this.filterTypes.forEach(filterType => this.bindFilterType(filterType))

		this.eventEmitter.on('filter:open-mobile-nav', () => this.open())
	}

	bindFilterType(filterTypeElement) {
		let filterTypeCount = filterTypeElement.querySelector(
			'.mobile-filter__count'
		)
		if (!filterTypeCount) {
			return
		}

		// bind the checkboxes to update the filter type count when one is checked
		filterTypeElement
			.querySelectorAll('input[type="checkbox"]')
			.forEach(checkbox => {
				checkbox.addEventListener('change', () => {
					filterTypeCount.innerText = filterTypeElement.querySelectorAll(
						'input[type="checkbox"]:checked'
					).length
				})
			})
	}
}
